import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { getRemainingTime } from '@inyova/inyova-shared';

@Component({
  selector: 'app-reporting-dialog-odd',
  templateUrl: './reporting-dialog-odd.component.html',
  styleUrls: ['./reporting-dialog-odd.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ReportingDialogOddComponent implements OnInit {
  @Input() oddDate!: string;
  @Input() language: string;
  @Input() name: string;
  @Output() review: EventEmitter<void> = new EventEmitter<void>();
  @Output() doItLater: EventEmitter<void> = new EventEmitter<void>();

  days: number;
  date: string;

  ngOnInit() {
    this.days = getRemainingTime(this.oddDate).days;
    this.date = new Date(this.oddDate).toLocaleString(this.language, {
      year: 'numeric',
      day: 'numeric',
      month: 'long'
    });
  }

  onReview() {
    this.review.emit();
  }

  onDoItLater() {
    this.doItLater.emit();
  }
}
